export default __webpack_public_path__ + "static/media/letstango.9b0be795.png";